export default {
  title: 'Add-ons voor meer succes',
  description: 'Breid uw abonnement uit met extra functies',
  buttons: {
    continue: 'Doorgaan',
    no_app_for_now: 'Voorlopig geen mobiele app',
  },
  toasts: {
    something_went_wrong: 'Er is iets misgegaan, ververs de pagina of neem contact op met technische ondersteuning!',
    failed_to_save_changes: 'Wijzigingen konden niet worden opgeslagen, neem contact op met technische ondersteuning!',
    changes_got_saved: 'Wijzigingen zijn succesvol opgeslagen!',
  },
};
